"use strict";

module.exports = function (accumulator) {
  return accumulator + ' - TWO COPIES OF THIS FILE ARE NEEDED';
};